import React, { useEffect, useState } from 'react';
import { Button, Col, Row } from 'react-bootstrap';
import { Link, useLocation, useNavigate, useParams } from 'react-router-dom';
import { WebApiCalls } from '../../webApiCalls/WebApiCalls';
import _ from 'lodash';
import { useAuth } from '../../hooks/useAuth';
import { toast } from 'react-toastify';
import { PDFDownloadLink } from '@react-pdf/renderer';
import BookingDetailsPdf from './BookingDetailsPdf';
import { errorMessageString } from '../../helpers/utils';
import moment from 'moment';
const BookingDetails = () => {
    const [data, setData] = useState();
    const [unitConfig, setUnitConfig] = useState({});
    const navigate = useNavigate();
    const { getToken, user } = useAuth();
    const { state } = useLocation();
    const params = useParams();
    useEffect(() => {
        if (state?.trip_id || params?.id) {
            getUnitConfig();
            getBookingDetails(state?.trip_id || params?.id);
        }
    }, []);
    const getUnitConfig = async () => {
        const token = getToken();
        new WebApiCalls()
            .getRewardSettings(token)
            .then((res) => {
                setUnitConfig(res.data);
            })
            .catch((err) => {
                toast.error('Something went wrong while fetching units');
            });
    };
    const getBookingDetails = async (id = '') => {
        const token = getToken();
        if (id && token) {
            new WebApiCalls()
                .bookingDetials(token, id)
                .then((res) => {
                    if (res?.code === 200) {
                        setData(res?.data);
                    }
                })
                .catch((err) => {
                    let errorMessage = errorMessageString(err);

                    toast.error(errorMessage);
                });
        }
    };
    const handleBackClick = () => {
        navigate(-1);
    };

    return (
        <>
            <div className="d-flex justify-content-end align-items-center gap-2">
                {data?.booking && (
                    <PDFDownloadLink document={<BookingDetailsPdf data={data?.booking} unitConfig={unitConfig} />} fileName="bookingDetail.pdf">
                        <Button className="export-file justify-content-center  align-items-center" style={{ background: '#198754', minWidth: '150px' }}>
                            Export Details
                        </Button>
                    </PDFDownloadLink>
                )}

                <Button onClick={handleBackClick} className="theme-cancel-btn px-5 py-2">
                    Close
                </Button>
            </div>
            {/* <Row>
                <Col sm={4}>
                    <div className="detail-heading ms-5">Agency Details</div>
                </Col>
            </Row> */}
            <Row className="d-flex justify-content-center">
                <Col xs={12} sm={12} md={11} lg={11} className="p-4 m-3 ">
                    <Row>
                        <Col sm={6} md={2} className="mb-4">
                            <div className="detail-small-heading">Agency Name</div>
                            <div className="detail-value">{data?.booking?.transit_agency?.name}</div>
                        </Col>

                        {user?.role !== 'commuter' && (
                            <Col sm={6} md={2} className="mb-4">
                                <div className="detail-small-heading">Commuter Name</div>
                                <div className="detail-value">{data?.booking?.commuter?.name}</div>
                            </Col>
                        )}

                        <Col sm={6} md={2} className="mb-4">
                            <div className="detail-small-headingg">Transit Type</div>
                            <div className="detail-value">{data?.booking?.transit_type}</div>
                        </Col>

                        <Col sm={6} md={2} className="mb-4">
                            <div className="detail-small-heading">Starting Stop</div>
                            <div className="detail-value">{data?.booking?.starting_station?.name}</div>
                        </Col>

                        <Col sm={6} md={2} className="mb-4">
                            <div className="detail-small-heading">Ending Stop</div>
                            <div className="detail-value">{data?.booking?.last_station?.name}</div>
                        </Col>

                        <Col sm={6} md={2} className="mb-4">
                            <div className="detail-small-heading">Status</div>
                            <div className="detail-value">{data?.booking?.status}</div>
                        </Col>

                        {/* <Col sm={6} md={2} className="mb-4">
                            <div className="detail-small-heading">Average Speed</div>
                            <div className="detail-value">
                                {data?.trip?.average_speed || 0}
                                {data?.trip?.average_speed ? unitConfig.distanceUnit : null}
                            </div>
                        </Col> */}
                        <Col sm={6} md={2} className="mb-4">
                            <div className="detail-small-heading">Distance</div>
                            <div className="detail-value">
                                {data?.trip?.distance || 0}
                                {data?.trip?.distance ? unitConfig.distanceUnit : null}
                            </div>
                        </Col>
                        <Col sm={6} md={2} className="mb-4">
                            <div className="detail-small-heading">GHG Saved</div>
                            <div className="detail-value">
                                {data?.trip?.ghg_saved || 0}
                                {data?.trip?.ghg_saved ? unitConfig.ghgUnit : null}
                            </div>
                        </Col>

                        <Col sm={6} md={2} className="mb-4">
                            <div className="detail-small-heading">Points Earned</div>
                            <div className="detail-value">{data?.trip?.points_earned || 0}</div>
                        </Col>
                        <Col sm={6} md={2} className="mb-4">
                            <div className="detail-small-heading">Total Amount</div>
                            <div className="detail-value">$ {data?.booking?.payment?.totalAmount / 100 || 1}</div>
                        </Col>

                        <Col sm={6} md={2} className="mb-4">
                            <div className="detail-small-heading">Route Short Name</div>
                            <div className="detail-value">{data?.booking?.route?.short_name || 'N/A'}</div>
                        </Col>
                        <Col sm={6} md={2} className="mb-4">
                            <div className="detail-small-heading">Route Long Name</div>
                            <div className="detail-value">{data?.booking?.route?.long_name || 'N/A'}</div>
                        </Col>
                        <Col sm={6} md={2} className="mb-4">
                            <div className="detail-small-heading">Trip Headsign</div>
                            <div className="detail-value">{data?.booking?.trip?.trip_headsign || 'N/A'}</div>
                        </Col>

                        <Col sm={6} md={2} className="mb-4">
                            <div className="detail-small-heading">Start Date & Time</div>
                            <div className="detail-value">{data?.trip?.started_at ? moment(data?.trip?.started_at).format('YYYY-MM-DD HH:mm:ss') : 'N/A'}</div>
                        </Col>
                        <Col sm={6} md={2} className="mb-4">
                            <div className="detail-small-heading">End Date & Time</div>
                            <div className="detail-value">{data?.trip?.finished_at ? moment(data?.trip?.finished_at).format('YYYY-MM-DD HH:mm:ss') : 'N/A'}</div>
                        </Col>
                        <Col sm={6} md={2} className="mb-4">
                            <div className="detail-small-heading">Duration</div>
                            <div className="detail-value">
                                {data?.trip?.started_at && data?.trip?.finished_at
                                    ? moment.duration(moment(data?.trip?.finished_at).diff(moment(data?.trip?.started_at))).humanize()
                                    : 'N/A'}
                            </div>
                        </Col>
                    </Row>
                </Col>
            </Row>
        </>
    );
};

export default BookingDetails;
